var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "33", height: "35", viewBox: "0 0 33 35", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 16.579V5.526L16.5 0 11 5.526v3.685H0V35h33V16.579H22zM7.333 31.316H3.667v-3.684h3.666v3.684zm0-7.369H3.667v-3.684h3.666v3.684zm0-7.368H3.667v-3.684h3.666v3.684zm11 14.737h-3.666v-3.684h3.666v3.684zm0-7.369h-3.666v-3.684h3.666v3.684zm0-7.368h-3.666v-3.684h3.666v3.684zm0-7.368h-3.666V5.526h3.666v3.685zm11 22.105h-3.666v-3.684h3.666v3.684zm0-7.369h-3.666v-3.684h3.666v3.684z", fill: "#96CF91" })
  );
});